import { useState } from "react";
import { AlertTriangle, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

/** Scoped to one impersonation session — cleared on switch back / sign out. */
const HIDDEN_KEY = "podgo_impersonation_banner_hidden";

export function ImpersonationBanner() {
  const { isImpersonating, impersonatingAs, switchBack } = useAuth();
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(HIDDEN_KEY) === "true",
  );

  if (!isImpersonating || dismissed) return null;

  const hide = () => {
    sessionStorage.setItem(HIDDEN_KEY, "true");
    setDismissed(true);
  };

  return (
    <div
      className="border-b border-accent-gold/50 px-4 py-2 flex items-center justify-center gap-3 text-sm"
      style={{ backgroundColor: "hsl(41 78% 82%)" }}
    >
      <AlertTriangle className="h-4 w-4 text-accent-gold shrink-0" />
      <span className="text-foreground font-medium">
        You are viewing as <strong>{impersonatingAs || 'another user'}</strong>
      </span>
      <Button
        size="sm"
        variant="outline"
        className="h-7 text-xs border-accent-gold/50 hover:bg-accent-gold/20"
        onClick={switchBack}
      >
        Switch Back
      </Button>
      <Button
        size="icon"
        variant="ghost"
        aria-label="Hide banner"
        title="Hide until you switch back"
        className="h-7 w-7 shrink-0 text-foreground hover:bg-accent-gold/20"
        onClick={hide}
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}
